import { render, staticRenderFns } from "./MajorRanking.vue?vue&type=template&id=5b070f00&scoped=true"
import script from "./MajorRanking.vue?vue&type=script&lang=js"
export * from "./MajorRanking.vue?vue&type=script&lang=js"
import style0 from "./MajorRanking.vue?vue&type=style&index=0&id=5b070f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b070f00",
  null
  
)

export default component.exports